export function initPanelAnchor(): void {
  const buttons = document.querySelectorAll<HTMLElement>('.js-comfort-anchor');

  if (!buttons.length) return;

  buttons.forEach((btn) => {
    const targetId = btn.dataset.target;
    if (!targetId) return;

    // クリックでターゲットセクションへスムーススクロール
    btn.addEventListener('click', () => {
      const target = document.getElementById(targetId);
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // is-passed の判定対象要素（data-passed-target があればそちらを使用）
    const passedTargetId = btn.dataset.passedTarget ?? targetId;
    const passedTarget = document.getElementById(passedTargetId);
    if (!passedTarget) return;

    const useEnterTrigger = !!btn.dataset.passedTarget;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (useEnterTrigger) {
            // ビューポートに入ったら、またはスクロール通過済みなら is-passed
            if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
              btn.classList.add('is-passed');
            } else {
              btn.classList.remove('is-passed');
            }
          } else {
            // top < 0 = セクションがビューポートより上（通過済み）
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
              btn.classList.add('is-passed');
            } else {
              btn.classList.remove('is-passed');
            }
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(passedTarget);
  });
}
